import React from 'react'
import {MessageCircleDashed as MessageCircle, Navigation, Phone, Sparkles, Clock, Shield} from 'lucide-react'

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-900">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=1920')] bg-cover bg-center opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
          <div className="text-center">
            <div className="inline-block mb-4">
              <span className="bg-red-600/20 text-red-400 px-4 py-2 rounded-full text-sm font-semibold border border-red-500/30">
                ✨ Official North Pole Communication Hub
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6">
              Get Real Texts from<br />
              <span className="text-red-500">Santa in 2025!</span>
            </h1>
            <p className="text-xl sm:text-2xl text-white/80 mb-8 max-w-3xl mx-auto">
              The official Santa Communication Hub for the texting generation.
            </p>
            <button className="bg-red-600 hover:bg-red-500 text-white px-8 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105 shadow-lg hover:shadow-red-500/50">
              Start Texting Santa
            </button>
            <p className="text-white/60 mt-4 text-sm">Join 100,000+ families connecting with the North Pole</p>
          </div>
        </div>
      </section>

      {/* Feature Section - Three Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-blue-950 mb-4">
              Modern Ways to Connect with Santa
            </h2>
            <p className="text-xl text-gray-600">
              Experience the magic of Christmas through cutting-edge North Pole technology
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Real-time Santa Tracker 2025 */}
            <div className="bg-gradient-to-br from-blue-50 to-red-50 rounded-2xl p-8 border-2 border-blue-200 hover:border-red-500 transition-all transform hover:scale-105">
              <div className="bg-blue-900 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Navigation className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-blue-950 mb-4">Real-time Santa Tracker 2025</h3>
              <p className="text-gray-700 mb-4">
                Track Santa's exact location on Christmas Eve with live updates. Get instant SMS notifications asking "Where is Santa Now?" powered by NORAD and Google Santa Tracker technology.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Live GPS tracking of Santa's sleigh</span>
                </li>
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>SMS alerts when Santa is near</span>
                </li>
              </ul>
            </div>

            {/* Direct Messages from Santa */}
            <div className="bg-gradient-to-br from-red-50 to-blue-50 rounded-2xl p-8 border-2 border-red-200 hover:border-blue-500 transition-all transform hover:scale-105">
              <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <MessageCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-blue-950 mb-4">Direct Messages from Santa</h3>
              <p className="text-gray-700 mb-4">
                Receive personalized text messages from Santa himself! Get a real Message from Santa with encouragement, holiday wishes, and updates from the North Pole workshop.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Personalized texts for your child</span>
                </li>
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Two-way messaging with Santa</span>
                </li>
              </ul>
            </div>

            {/* Personalized Santa Calls */}
            <div className="bg-gradient-to-br from-blue-50 to-red-50 rounded-2xl p-8 border-2 border-blue-200 hover:border-red-500 transition-all transform hover:scale-105">
              <div className="bg-blue-900 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-blue-950 mb-4">Personalized Santa Calls</h3>
              <p className="text-gray-700 mb-4">
                Experience the magic of Calling Santa! Schedule a personalized video or voice call where Santa mentions your child by name and talks about their wish list.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Custom video messages</span>
                </li>
                <li className="flex items-start">
                  <Sparkles className="w-5 h-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span>Scheduled surprise calls</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-20 bg-gradient-to-b from-blue-950 to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              Why Families Love TextingSanta
            </h2>
            <p className="text-xl text-white/80">
              Join thousands of families creating magical Christmas memories in 2025
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <Clock className="w-12 h-12 text-red-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">Instant Delivery</h3>
              <p className="text-white/70">
                Get responses from Santa in minutes, not weeks. No more waiting for USPS Santa Letters!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <Shield className="w-12 h-12 text-red-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">100% Secure</h3>
              <p className="text-white/70">
                Your family's privacy is protected with North Pole-grade encryption technology.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <Sparkles className="w-12 h-12 text-red-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">Pure Magic</h3>
              <p className="text-white/70">
                Create unforgettable Christmas moments with AI-powered Santa experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Ready to Connect with the North Pole?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Start your magical journey today. Message from Santa awaits!
          </p>
          <button className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105 shadow-lg">
            Start Texting Santa Now
          </button>
        </div>
      </section>
    </div>
  )
}
